// Respuesta correcta de cada uno de los 101 ítems del TECAL.
//
// La autoridad es el servidor: cada campo `pN` del modelo Tecal en newredpsi
// (apps/tecal/models.py) lleva su respuesta correcta como verbose_name, y
// `analizar()` puntúa comparando la respuesta enviada contra ese verbose_name:
//
//     monto = 1 if getattr(self, campo.name) == campo.verbose_name else 0
//
// Esta tabla NO es de display: `buildPayload` manda estos valores por los ítems
// que la profesional deja en blanco, así que un valor equivocado acá se cuenta
// como un error del niño y le baja el puntaje. Se generó leyendo el modelo del
// servidor, no a mano.

export const TECAL_CORRECT = [
  //   1- 10
  2, 2, 1, 3, 1, 3, 1, 1, 3, 2,
  //  11- 20
  1, 1, 3, 2, 1, 3, 1, 2, 3, 1,
  //  21- 30
  1, 3, 3, 2, 3, 3, 1, 2, 1, 1,
  //  31- 40
  3, 3, 1, 2, 3, 2, 1, 1, 2, 3,
  //  41- 50
  1, 2, 2, 1, 3, 2, 1, 2, 1, 1,
  //  51- 60
  3, 2, 3, 2, 1, 2, 1, 1, 2, 1,
  //  61- 70
  3, 3, 1, 1, 2, 1, 3, 1, 2, 1,
  //  71- 80
  3, 2, 2, 3, 3, 1, 3, 1, 2, 1,
  //  81- 90
  1, 3, 2, 3, 2, 2, 1, 3, 1, 1,
  //  91-100
  2, 1, 1, 3, 2, 1, 3, 3, 2, 2,
  // 101-101
  1,
];
